// TIDAK TERPAKAI — halaman V1, tidak terjangkau sejak App.js mengarahkan semua rute ke V2App. Jangan diedit. Lihat memory/DEPRECATED.md.
// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE
// version  : 1.0
// updated  : 2026-06-15
// replaces : -
// protected: NO  -> Tambahkan riwayat di /app/memory CHANGELOG saat diubah.
// =============================================================================

import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { allowedFor } from "@/components/AppShell";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BookOpen, GitBranch, ShieldCheck, ClipboardList, CheckCircle2, Smartphone } from "lucide-react";

const ROLE_LABEL = {
  OWNER: "Owner (Semua Akses)",
  ADMIN_PRODUKSI_SBY: "Admin Produksi Surabaya", ADMIN_PRODUKSI_SMD: "Admin Produksi Samarinda",
  ADMIN_GUDANG_SBY: "Admin Gudang Surabaya", ADMIN_GUDANG_SMD: "Admin Gudang Samarinda",
  KACAB_SBY: "Kepala Cabang Surabaya", KACAB_SMD: "Kepala Cabang Samarinda",
  KEPALA_STORE_AREMA: "Staff Store Arema", KEPALA_STORE_BORNEO: "Staff Store Borneo",
};

const PROD = (club) => ({
  intro: `Anda mengelola produksi jersey ${club}. Tugas utama Anda adalah membuat Work Order dan memastikan setiap item produksi memiliki QR.`,
  flow: [
    "Buat Work Order (menu Work Order): pilih klub, merchandize, dan jumlah per ukuran.",
    "Kirim Work Order untuk disetujui Kepala Cabang.",
    "Setelah disetujui, sistem otomatis membuat item + QR unik per pcs (mis. AFC-YYMMDD-0001).",
    "Buka detail Work Order untuk mencetak label QR setiap item.",
    "Serahkan barang hasil produksi ke Gudang untuk dicatat sebagai stok.",
  ],
  wewenang: [
    "Membuat & mengelola Work Order produksi untuk region Anda.",
    "Mencetak label QR item hasil produksi.",
    "Melihat Laporan produksi & penjualan region Anda.",
  ],
  kewajiban: [
    "Memastikan jumlah dan ukuran pada Work Order sudah benar sebelum dikirim untuk disetujui.",
    "Memastikan seluruh QR tercetak dan tertempel pada barang.",
    "Menyerahkan barang produksi ke gudang secara lengkap.",
  ],
});

const WH = (region) => ({
  intro: `Anda mengelola stok gudang & distribusi region ${region}. Anda menjadi pintu masuk-keluar barang di gudang.`,
  flow: [
    "Terima barang hasil produksi ke gudang (menu Gudang → Masuk Gudang, scan QR).",
    "Untuk Transfer/Pengiriman yang dibuat Kepala Cabang: buka dokumen berstatus 'Disiapkan', lalu scan barang untuk menerbitkan Surat Jalan.",
    "Konfirmasi penerimaan Transfer dari gudang lain dengan memindai QR (menu Transfer Gudang).",
    "Terima & proses barang Retur dari store (menu Retur).",
  ],
  wewenang: [
    "Menerima barang produksi ke gudang.",
    "Menerbitkan Surat Jalan Transfer & Pengiriman melalui scan QR.",
    "Mengonfirmasi penerimaan transfer antar gudang.",
    "Menerima dan memproses retur dari store.",
  ],
  kewajiban: [
    "Memastikan stok fisik sama dengan catatan sistem.",
    "Scan barang dengan akurat saat menerbitkan Surat Jalan.",
    "Memproses retur dan transfer masuk tepat waktu.",
  ],
});

const KACAB = (region, club) => ({
  intro: `Anda memantau & menyetujui operasional region ${region} (${club}). Anda adalah pengambil keputusan distribusi region.`,
  flow: [
    "Pantau penjualan & stok region Anda di Dashboard.",
    "Setujui Work Order produksi sebelum QR dibuat.",
    "Buat rincian Transfer Gudang & Pengiriman ke Store untuk region Anda.",
    "Setujui Permintaan Barang dari store.",
    "Terbitkan Invoice Penagihan bulanan ke store.",
  ],
  wewenang: [
    "Menyetujui/menolak Work Order & Permintaan Barang region Anda.",
    "Membuat rincian Transfer Gudang & Pengiriman ke Store.",
    "Mengeluarkan Compliment langsung dari Gudang region Anda.",
    "Menerbitkan Invoice Penagihan & mengakses seluruh Laporan region Anda.",
  ],
  kewajiban: [
    "Mereview Work Order sebelum menyetujui agar produksi sesuai kebutuhan.",
    "Memastikan distribusi barang ke store sesuai permintaan.",
    "Menagih store tepat waktu melalui Invoice Penagihan.",
  ],
});

const STORE = (club, store) => ({
  intro: `Anda mengelola penjualan ${store}. Fokus Anda adalah transaksi penjualan dan pelayanan pelanggan.`,
  flow: [
    "Terima pengiriman dari gudang dengan memindai QR (menu Pengiriman Store).",
    "Jual jersey di menu Penjualan: scan QR item, atur diskon bila ada, pilih metode pembayaran.",
    "Isi email pembeli agar Invoice (PDF) otomatis terkirim. (Tidak ada struk thermal.)",
    "Catat transaksi Compliment (gratis) bila perlu.",
    "Ajukan Permintaan Barang ke gudang, dan ajukan Retur untuk barang cacat.",
  ],
  wewenang: [
    "Melakukan penjualan jersey & memberi diskon sesuai tier yang berlaku.",
    "Mencatat transaksi Compliment di store.",
    "Mengajukan Permintaan Barang dan Retur ke gudang.",
    `Melihat laporan & data yang berkaitan dengan ${store} saja.`,
  ],
  kewajiban: [
    "Memindai QR saat menerima pengiriman agar stok store akurat.",
    "Mengisi email pembeli agar invoice terkirim.",
    "Menjaga kesesuaian stok fisik store dengan sistem.",
  ],
});

const GUIDES = {
  OWNER: {
    intro: "Anda memiliki akses penuh ke seluruh sistem & semua region.",
    flow: [
      "Pantau ringkasan penjualan semua region di Dashboard (tab Owner / Arema / Borneo).",
      "Kelola produk & harga di menu Merchandize, dan kelola akun di User Management (maks. 2 email per role).",
      "Pantau laporan penjualan, Rekap MoU, Rekap Stock, dan Laporan Mutasi.",
      "Gunakan 'Lihat sebagai' untuk meninjau aplikasi persis seperti role lain (data ikut dibatasi).",
    ],
    wewenang: [
      "Akses penuh ke semua region, menu, dan laporan.",
      "Mengelola produk/harga dan akun pengguna.",
      "Mengeluarkan Compliment dari gudang mana pun.",
      "Mengakses Backup Data & Audit Trail.",
    ],
    kewajiban: [
      "Memastikan data master (produk, harga, user) akurat.",
      "Memantau Audit Trail untuk aktivitas mencurigakan.",
      "Memastikan backup database berjalan.",
    ],
  },
  ADMIN_PRODUKSI_SBY: { region: "Arema FC", ...PROD("Arema FC") },
  ADMIN_PRODUKSI_SMD: { region: "Borneo FC", ...PROD("Borneo FC") },
  ADMIN_GUDANG_SBY: { region: "Surabaya", ...WH("Surabaya") },
  ADMIN_GUDANG_SMD: { region: "Samarinda", ...WH("Samarinda") },
  KACAB_SBY: { region: "Surabaya", ...KACAB("Surabaya", "Arema FC") },
  KACAB_SMD: { region: "Samarinda", ...KACAB("Samarinda", "Borneo FC") },
  KEPALA_STORE_AREMA: { region: "Arema FC", ...STORE("Arema FC", "Store Arema") },
  KEPALA_STORE_BORNEO: { region: "Borneo FC", ...STORE("Borneo FC", "Store Borneo") },
};

const SCANNER_TIP = "Anda bisa memakai HP sebagai scanner. Buka menu QR Scanner, pilih 'Pakai HP sebagai Scanner', hubungkan dengan layar laptop/komputer, lalu hasil scan otomatis masuk ke laptop.";

const Section = ({ icon: Icon, title, tone, items }) => (
  <Card className="p-5 rounded-2xl kpi-shadow">
    <div className="flex items-center gap-2 mb-3">
      <span className={`w-8 h-8 rounded-lg flex items-center justify-center ${tone}`}><Icon className="w-4 h-4" /></span>
      <h3 className="font-semibold text-sm">{title}</h3>
    </div>
    <ul className="space-y-2">
      {items.map((s, i) => (
        <li key={i} className="flex gap-2 text-sm">
          <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-muted-foreground" /><span>{s}</span>
        </li>
      ))}
    </ul>
  </Card>
);

export default function Panduan() {
  const { user } = useAuth();
  const isOwner = user?.role === "OWNER";
  const [viewRole, setViewRole] = useState(user?.role || "OWNER");
  const role = isOwner ? viewRole : user?.role;
  const guide = GUIDES[role];
  const menus = allowedFor(role);

  return (
    <div>
      <PageHeader title="Petunjuk Penggunaan" subtitle="Alur kerja, wewenang, dan kewajiban sesuai peran Anda di sistem ETAMS.">
        {isOwner && (
          <Select value={viewRole} onValueChange={setViewRole}>
            <SelectTrigger className="h-9 w-[230px]" data-testid="panduan-role-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {Object.keys(GUIDES).map((r) => <SelectItem key={r} value={r}>{ROLE_LABEL[r]}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
      </PageHeader>

      {!guide ? (
        <Card className="p-8 rounded-2xl kpi-shadow text-center text-muted-foreground">Panduan untuk peran ini belum tersedia.</Card>
      ) : (
        <div className="space-y-5" data-testid="panduan-content">
          <Card className="p-5 rounded-2xl kpi-shadow bg-primary text-primary-foreground">
            <div className="flex items-start gap-3">
              <span className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center shrink-0"><BookOpen className="w-5 h-5" /></span>
              <div>
                <div className="flex items-center gap-2 flex-wrap">
                  <h2 className="text-lg font-semibold font-display">{ROLE_LABEL[role]}</h2>
                  {guide.region && <Badge variant="secondary" className="bg-white/15 text-primary-foreground border-0">{guide.region}</Badge>}
                </div>
                <p className="text-sm text-primary-foreground/80 mt-1">{guide.intro}</p>
              </div>
            </div>
          </Card>

          <Section icon={GitBranch} title="Alur Kerja (Flow)" tone="bg-primary/10 text-primary" items={guide.flow} />

          <div className="grid lg:grid-cols-2 gap-5">
            <Section icon={ShieldCheck} title="Wewenang" tone="bg-[hsl(var(--badge-success))]/10 text-[hsl(var(--badge-success))]" items={guide.wewenang} />
            <Section icon={ClipboardList} title="Kewajiban" tone="bg-[hsl(var(--badge-warning))]/10 text-[hsl(var(--badge-warning))]" items={guide.kewajiban} />
          </div>

          <Card className="p-5 rounded-2xl kpi-shadow">
            <div className="flex items-start gap-2 text-sm text-muted-foreground bg-muted rounded-lg p-3 mb-4">
              <Smartphone className="w-4 h-4 mt-0.5 shrink-0 text-[hsl(var(--accent))]" /><span>{SCANNER_TIP}</span>
            </div>
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">Menu yang bisa diakses</p>
            <div className="flex flex-wrap gap-2">
              {menus.map((m) => (
                <span key={m.to} className="inline-flex items-center gap-1.5 text-xs bg-secondary text-secondary-foreground rounded-lg px-2.5 py-1">
                  <m.icon className="w-3.5 h-3.5" /> {m.label}
                </span>
              ))}
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
